import { Customer } from "./customer";
import { RoleResponse } from "./roleresponse";
import { Position } from "./userPosition";

export interface IUserResponse {
    userId: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountType?: string | undefined;
    password?: string | undefined;
    isUserEnabled: boolean;
    practiceName?: string | undefined;
    companyName?: string | undefined;
    createdDate: Date;
    lastUpdatedDate: Date;
    userRole:RoleResponse;
    impersonatedUsers:Array<UserResponse> |undefined;
    customer?:Customer | undefined;
    hasProviderCredentials:boolean|false;
    title:string | undefined;
    userPosition?:Position|undefined;
   // userType?:RoleResponse|undefined;
  }
  
export class UserResponse implements IUserResponse {
    userId!: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountType?: string | undefined;
    password?: string | undefined;
    isUserEnabled!: boolean;
    practiceName?: string | undefined;
    companyName?: string | undefined;
    createdDate!: Date;
    lastUpdatedDate!: Date;
    userRole:RoleResponse;
    impersonatedUsers:Array<UserResponse> |undefined;
    customer?:Customer | undefined;
    hasProviderCredentials:boolean|false;
    title:string | undefined;
    userPosition?:Position|undefined;
    //userType?:RoleResponse|undefined;
    isSelected:boolean;
    constructor(data?: IUserResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  
    init(_data?: any) {
      if (_data) {
        this.userId = _data["userId"];
        this.userName = _data["userName"];
        this.firstName = _data["firstName"];
        this.lastName = _data["lastName"];
        this.accountType = _data["accountType"];
        this.password = _data["password"];
        this.isUserEnabled = _data["isUserEnabled"];
        this.practiceName = _data["practiceName"];
        this.companyName = _data["companyName"];
        this.createdDate = _data["createdDate"]? new Date(_data["createdDate"].toString()): <any>undefined;
        this.lastUpdatedDate = _data["lastUpdatedDate"]? new Date(_data["lastUpdatedDate"].toString()): <any>undefined;
        this.userRole=_data["userRole"]?RoleResponse.fromJS(_data["userRole"]) : <any>undefined;
        if (Array.isArray(_data["impersonatedUsers"])) {
          this.impersonatedUsers = [] as Array<UserResponse>;
          for (let item of _data["impersonatedUsers"])
              this.impersonatedUsers!.push(item);
         }
         this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
         this.hasProviderCredentials = _data["hasProviderCredentials"];
         this.title = _data["title"];
         this.userPosition = _data["userPosition"] ? Position.fromJS(_data["userPosition"]) : <any>undefined;
         //this.userType=_data["userRole"]?RoleResponse.fromJS(_data["userRole"]) : <any>undefined;
      }
    }
  
    static fromJS(data: any): UserResponse {
      data = typeof data === "object" ? data : {};
      let result = new UserResponse();
      result.init(data);
      return result;
    }
  
    toJSON(data?: any) {
      data = typeof data === "object" ? data : {};
      data["userId"] = this.userId;
      data["userName"] = this.userName;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["accountType"] = this.accountType;
      data["password"] = this.password;
      data["isUserEnabled"] = this.isUserEnabled;
     
      data["practiceName"] = this.practiceName;
      data["companyName"] = this.companyName;
      data["userRole"] = this.userRole;
      data["createdDate"] = this.createdDate
        ? this.createdDate.toISOString()
        : <any>undefined;
      data["lastUpdatedDate"] = this.lastUpdatedDate
        ? this.lastUpdatedDate.toISOString()
        : <any>undefined;
        if (Array.isArray(this.impersonatedUsers)) {
          data["impersonatedUsers"] = [];
          for (let item of this.impersonatedUsers)
              data["impersonatedUsers"].push(item);
      }
      data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
      data["hasProviderCredentials"] = this.hasProviderCredentials;
      data["title"] = this.title;
      data["userPosition"] = this.userPosition ?  this.userPosition.toJSON() : <any>undefined;
     // data["userRole"] = this.userType;
      return data;
    }
  }

  export interface IUserResponseMini {
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?:string | undefined;
    userRoleId?:number | undefined;
    title:string | undefined;
    userPositionId:number|undefined;
  }
  export class UserResponseMini implements IUserResponseMini
  {
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?:string | undefined;
    title:string | undefined;
    userRoleId?:number | undefined;
    userPositionId:number|undefined;
    constructor(data?: IUserResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }
    init(_data?: any) {
      if (_data) {
       
        this.firstName = _data["firstName"];
        this.lastName = _data["lastName"];
        this.userName = _data["userName"];
        
        this.userRoleId = _data["userRoleId"];
        this.title = _data["title"];
        this.userPositionId = _data["userPositionId"];
      }
    }
    static fromJS(data: any): UserResponse {
      data = typeof data === "object" ? data : {};
      let result = new UserResponse();
      result.init(data);
      return result;
    }
    toJSON(data?: any) {
      data = typeof data === "object" ? data : {};
     
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["userName"] = this.userName;
      data["userRoleId"] = this.userRoleId;
      data["title"] = this.title;
      data["userPositionId"] = this.userPositionId;
      return data;
    }
    
  }

  
  export interface IUserResponseAfterCreate {
    message?: string | undefined;
    id?: number | undefined;
   
  }
  export class UserResponseAfterCreate implements IUserResponseAfterCreate
  {
    message?: string | undefined;
    id?: number | undefined;
   
    constructor(data?: IUserResponseAfterCreate) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }
    init(_data?: any) {
      if (_data) {
       
        this.message = _data["message"];
        this.id = _data["id"];
       
      }
    }
    static fromJS(data: any): UserResponseAfterCreate {
      data = typeof data === "object" ? data : {};
      let result = new UserResponseAfterCreate();
      result.init(data);
      return result;
    }
    toJSON(data?: any) {
      data = typeof data === "object" ? data : {};
     
      data["message"] = this.message;
      data["id"] = this.id;
     
      return data;
    }
    
  }